export default __webpack_public_path__ + "efabda8d2e7296aa2450b44d885b3c1e.png";